import { forwardRef } from 'react'
import joinClassNames from './joinClassNames.js'

function resolveInvalidState({ invalid, error, 'aria-invalid': ariaInvalid }) {
  if (invalid === true || error === true) return true
  if (invalid === false || error === false) return false
  if (ariaInvalid === true || ariaInvalid === 'true') return true
  return false
}

/**
 * @param {import('./index.d.ts').InputProps} props
 */
const Input = forwardRef(function Input(
  {
    className = '',
    invalid,
    error,
    'aria-invalid': ariaInvalid,
    ...props
  },
  ref,
) {
  const hasError = resolveInvalidState({ invalid, error, 'aria-invalid': ariaInvalid })
  return (
    <input
      ref={ref}
      className={joinClassNames('input', hasError ? 'input-error' : '', className)}
      aria-invalid={hasError ? true : ariaInvalid}
      {...props}
    />
  )
})

export default Input
